
export const loggedIn = () => {
    return localStorage.getItem("user") === null ? false : true;
}

export const currentUser = () => {
    //console.log("currentUser", loggedIn(), location.hostname);
    if (loggedIn()) {
        return JSON.parse(localStorage.getItem('user'));
    } else if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
        //console.log(location.hostname);
        return {
            "rutUsuario": 22222221, // 14263516 76403285 22222221
            "nombreUsuario": "Analista Defensa",//"Raquel Rojas ",
            "rutOrganizacion": 99061000,
            "nombre_organizacion": "Liberty Compañia De Seguros Generales S.A.",
            "paisOrganizacion": 56,
            "userName": "rarojas",
            "codMonedaLocal":"30001",
            "monedaLocal":"Pesos CLP",
            "codMonedaConsolida":"30003",
            "monedaConsolida":"UF",
            "sigar":"0",
            "token": {
                "accessToken": "eyJraWQiOiJtQzhuODFcLzNJQnFDXC8xSWJlcVV0TUVVc0ZSc2c3QjkyOXJNbXFpQzlEQkk9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiI1NmRkZDUyZS0zOWFlLTQ4YzUtYjVlMS02NjQ0ZTE2ODMyNjYiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV83cGtvY1NGV0kiLCJjbGllbnRfaWQiOiI0ZTNhMnJ0MDYyNXVhMHFkdGF0cDFpMTZvdSIsIm9yaWdpbl9qdGkiOiIyNGY0ZjYxMS02NmQwLTQ4ZDktYWUzYi0zNzI2OWE5NjI5MTkiLCJldmVudF9pZCI6ImNiYWUxODY5LTMzMWItNDI2OS1hZmZmLTQwNjYxMWRjNTg4OSIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2NTQ4ODIxNjMsImV4cCI6MTY1NDg4NTc2MywiaWF0IjoxNjU0ODgyMTYzLCJqdGkiOiI1NjUzNGJhOS1mZmI4LTQ1NzctYTY1MS1mNjlmZGZlNGFiMjIiLCJ1c2VybmFtZSI6InJhcm9qYXMifQ.bvt7DPaFYVuj_UB2VDugN0q1gmzw0UCq19u3fb-FdYRCyptQCZy_H0LYerm2ZwpwMJJ4iRg7YX-YzdEQzoX-GLPN7b6yqqRkND3omblzFiYJdIheaxbjAX0S5aZ8D5v0dWXdDeKrUjMNH5k9jODF8JcEMjAef1p6MBO5q0M8V2LWgi9tv9PbNMpiidQywKzaoJXnKaYyXboEq_CzdpxuQvjvtA9LDFbb0-Zg6KG1Zlv7wkyBHx2zt-VLB6tIwaZP9AfuKfkxiEQpyvpvOkuP5tptgEDTMVfxeVI5nU6gbzq5n-x-wBczJ3rd_RAsuqZeHo8NCOscN4_De9OcG1OYog",
                "refreshToken": "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.hxQWP1d_PVakmy0gFyz6FiHCLgpifNGJss06J_E4jAqc51DFz0GjU3zo2tfdNeUX-XMotm_JhRztQtT6kjqrpQumXlEvbM6KKEzw8fRih-wJpyGxTZ_K8G9knVAotGE9wdDacZxgJxQpwGPSQvr9sCopkPhQBAFqYbjXAq3l0JEgmCQuouuCNQyh2BHJomPJx3TPxqXZwBbWRd5-78myQiph9tGtM8QRSXvg1MPYzEomgs96UyNXICrsdn2wpGkD1sC_xNKSYOoQsRx-IitxHa1TOwufz89nWZigAxQB8EwBXIHxfTSrbbw8YeS2o0YbyxvmRdvh0kl0hhOEQUJ-WA.Wj2cc_g_TAnvQL_k.hYCNBKBcdAjovBaMjq2C-J8VpCMZgefeXgVXHJFIN3J6iSzWRNX1qY7tB5T8kMkbELqH_DcnmJPYREuJ4W3twt1p7Ob_qtZ1tXiVbtXgxuIjgm8ZXrR-wIEt90Ro2LEbjAYtkSEmuKDOYxBZvB11Re5lO_8IgIlIewMiNCwgKKHwpRDhV3FD6FB8GZSww84YG9TSToce1WWuLiTvkzJMao5QiIfYt0tGJowmdARHxe9iGIqKen4t_UcAP9Pq1HT-ckATp9GJzm3Fq9N4WJI8o_iuydmQMFnC9D9BP7RLx7DtnfX8R_9BF44YPdmh0qcSCtS-Y1-DgPC5B5UEJh_6hT1Das9Mlm5etA25WTsZyhMTf2qOACxrCDQQn-B93Ilxjr2L0IBhTY5l_tx7pSKHEKd2zFx9qlZbT2zVazdE0X7RVksZSt93ek4ybJmrMrHKMMJMlIB1b9p7AwR18_DWbgjgqH7GFRQArmY3ijUy3jzYFbNFMEBGq1P7Ua4QdsYSP1-Vkxc3Ccv4epB6EIuTzAGbHZOku_rngrmU6QNB_sZHlyx71WGx2mFfBdNS8hVRjmZpkLz1byRQ2q9r_H3hI9OpgqOhsjXTjwjA-6ZjfANJGTAy8F9sFVsbmiCijVAsxwmAaFIWWhdCY77Z4YALZjvqRD9dq4SBqm4iJQdNnWCmcnq8HAGyOXuMt_DMfFC04_PFLl6B2yjIoTsBzIW_zxnNAFqjUJ7bROiBwl6_JIpCwV31nEU3NVEs8sqwvAz7OgRV5XRALMaGe_dINn14tt3tZ4geHA9zdrXR3dDCmHDG2EhDX9wA7JDvTFCavXWCUBFPn5wDDJ6whaduSwHoV1oLZJ78a1DWP6COmF23uJl7OOCqnFjDw25ACm9eYXKlcvJCzUJKidyjVkhMRA_5DqWh2hVqkX1uGHmHO7eQSNgI8WjqAfwMyp5ma_bEzWbkD33KV4Uqc3QODN4uuqAiGDi6_TvumXVpjvGUXvLKDQN-HkehzZ8wDH5zKRFFVyPLRSRdvT2j3bG5o_bBVSPqlxVBIVY0ChCPI3XCxwORoB9c3Jp0jFiAoqbJZUZ5dKy7kqxJFvFVCBcqpU9AkiivBbpDpsV-65g1cyaEonwYqPEFFhzt5IK0Lu7nyclreOny5DmLSvXjmVIHV-mx8qcfPvli2MwVAGCw-r-Nq-IYs96kkjcQMZ3bQDQrsxYUHcRGSzi1L98jIm0Eqkgfvwz7NL_W8r9QjG_raG01OqNFImJ5yz_Fh1PoCu1iykleqEtbPVNLF60.x5-szuWkcRJVb8qyExvyrQ"
            },
            "opcionesMenu": [
                {
                    "name": "Ingreso de Caso",
                    "to": "/",
                    "iconClassName": "bi bi-chevron-down",
                    "subMenus": [
                        {
                            "name": "Carga Masiva",
                            "to": "carga-masiva",
                            "iconClassName": "bi bi-cloud-arrow-up"
                        }
                    ]
                },
                {
                    "name": "Tareas de Casos Pendientes",
                    "to": "area-trabajo",
                    "iconClassName": "bi bi-inbox",
                    "subMenus": []
                }
            ],
            "bandera": "🚩",
            "bandera1": "1f600",
            "esAbogado": false,
            "roles": [
                {
                    "rol": "0070RECUPER"
                },
                {
                    "rol": "70RESRECIAS"
                },
                {
                    "rol": "0070ANDEF0"
                }
            ]
        }
    }
}